// Strict inequality (!==): no type coercion between x and y.
export const different = (x, y) => x !== y
